// Tulevaisuustestaus v2 (#1474): future_reimagined.v2, the `futureV2` namespace. Its own file, as v1's
// futureReimaginedStrings.js; v1's wording where v2 is the same, vipupisteet where v1 had metrics.

export const futureReimaginedV2Fi = {
  loading: "Ladataan ratkaisuja…",
  loadError: "Tietojen lataus epäonnistui: {{message}}",
  tooFew: "Ristivaikutuksia voi tarkastella, kun Ratkaisuissa on vähintään kaksi arvioitua ratkaisua. Nyt niitä on {{count}}.",
  unassessed: "Näitä ratkaisuja ei ole vielä arvioitu, joten ne puuttuvat vertailusta: {{names}}",
  offMap: "Kirjoitettu vipupisteille, joita Ongelmakartta ei enää näytä (kartta ajettiin uudelleen): {{names}}. Niiden liikkeet puuttuvat ristivaikutuksista ja testistä; arvioi ne uudelleen Ratkaisuissa.",
  views: {
    select: "Valinta",
    analysis: "Analyysi",
    interplay: "Ristivaikutukset",
    timeline: "Aikajana",
    fates: "Kohtalot",
    vipupisteet: "Vipupisteet",
    compare: "Vertailu",
    needsCourse: "Analyysi avautuu, kun lukittu ratkaisujoukko on testattu skenaarioissa.",
    courseStatus: {
      beforeLock: "Analyysi avautuu, kun ratkaisut on lukittu ja fasilitaattori on testannut ne skenaarioissa.",
      waiting: "Ratkaisut on lukittu. Analyysi avautuu, kun fasilitaattori on testannut ne skenaarioissa.",
      running: "Ratkaisuja testataan skenaarioissa… Analyysi avautuu, kun testi valmistuu.",
      failed: "Tulevaisuuden kuvittelu epäonnistui. Fasilitaattori voi käynnistää sen uudelleen."
    },
  },
  stageBar: { label: "Vaiheet", interplay: "Ristivaikutukset", voting: "Äänestys", locked: "Lukitus", simulated: "Tulevaisuustestaus" },
  move: { as_intended: "Liikuttaa suuntaansa", against: "Liikuttaa suuntaansa vastaan" },
  matrix: {
    title: "Mitä kukin ratkaisu liikuttaa",
    hint: "Rivit ovat ratkaisuja, sarakkeet vipupisteitä. Nuoli kertoo ratkaisun arviosta, liikuttaako se vipupistettä sen omaan muutossuuntaan vai sitä vastaan.",
    sideEffect: "Sivuvaikutus (ei tavoiteltu)",
    untouched: "yksikään ratkaisu ei liikuta",
  },
  candidates: {
    title: "Mahdolliset ristivaikutukset",
    hint: "Laskettu ratkaisujen arvioista, vipupisteistä ja toteutuspoluista: mitä kahdella ratkaisulla on yhteistä. Tämä ei vielä ole tulkinta siitä, tukevatko ne toisiaan vai kilpailevatko ne.",
    none: "Ratkaisuilla ei ole yhteisiä vipupisteitä eikä toimijoita.",
    all: "Näytä kaikki {{count}} paria",
    fewer: "Näytä vähemmän",
  },
  signal: {
    similarity: "Liikuttavat samoja vipupisteitä {{percent}} %",
    opposed: "Vastakkain: {{name}}",
    same_harm: "Molemmat liikuttavat suuntaansa vastaan: {{name}}",
    same_good: "Molemmat liikuttavat: {{name}}",
    shared_target: "Kirjoitettu samaan vipupisteeseen: {{name}}",
    shared_actor: "Sama toimija: {{name}} ({{horizon}})",
  },
  interplay: {
    title: "Ristivaikutukset",
    hintUnread: "Alla näkyy, mitä ratkaisuilla on laskennallisesti yhteistä. Tekoäly lukee parit ja kertoo, menevätkö ratkaisut päällekkäin, kilpailevatko ne, ovatko ne ristiriidassa, mahdollistavatko tai vahvistavatko ne toisiaan – vai eivätkö ne vaikuta toisiinsa lainkaan.",
    hintRead: "Viivat ovat tekoälyn tulkinta siitä, miten ratkaisut vaikuttavat toisiinsa. Valitse ratkaisu nähdäksesi vain sen suhteet. Jokaisen suhteen perusta ja epävarmuus on kerrottu.",
    waiting: "Tekoäly ei ole vielä lukenut pareja. Fasilitaattori käynnistää luvun, ja tulos näkyy tässä, kun se valmistuu.",
    readAt: "Kuution luenta, {{time}}",
    stale: "Ratkaisuja on muutettu tai lisätty tämän lukeman jälkeen ({{names}}). Fasilitaattori voi lukea ristivaikutukset uudelleen ennen äänestystä.",
  },
  graph: { label: "Ratkaisujen väliset suhteet" },
  relation: { conflict: "Ristiriita", overlap: "Päällekkäisyys", competing: "Kilpailu", enables: "Mahdollistaa", reinforces: "Vahvistaa", independent: "Ei vaikutusta" },
  strength: { low: "Vähäinen merkitys", medium: "Kohtalainen merkitys", high: "Suuri merkitys" },
  basis: { research: "tutkimus", reasoned: "päättely" },
  cluster: { overlap: "Päällekkäinen ryhmä:", competing: "Kilpaileva ryhmä:", dependency: "Yhdestä riippuvat:" },
  relationCard: {
    why: "Miksi: perustelu, epävarmuus ja perusta",
    uncertainty: "Epävarmuus: {{text}}",
    via: "Kulkee: {{list}}",
    basis: "Perusta: {{basis}}",
    noneDrawn: "Tekoäly ei löytänyt pareilta päällekkäisyyksiä, kilpailua, ristiriitoja eikä riippuvuuksia.",
    showIndependent: "Näytä parit, jotka eivät vaikuta toisiinsa ({{count}})",
    hideIndependent: "Piilota parit, jotka eivät vaikuta toisiinsa ({{count}})",
    unanswered: "Tekoäly ei antanut arviota näille pareille: {{pairs}}",
    ragUnavailable: "Tutkimusaineistoon ei saatu yhteyttä, joten suhteet perustuvat päättelyyn.",
  },
  sources: { fold: "Lähteet ({{count}})", unavailable: "Lähteitä ei saatu haettua tällä kertaa." },
  vote: {
    title: "Äänestys: mitkä ratkaisut pidetään",
    hint: "Valitse ratkaisut, jotka viedään tulevaisuustestaukseen. Kortissa näkyy, mihin ratkaisu on ristivaikutusten mukaan kytköksissä. Voit perua äänen napauttamalla uudelleen.",
    left: "Ääniä jäljellä {{left}} / {{budget}}",
    noIdentity: "Tämä laite ei voi äänestää. Kirjaudu työpajan PIN-koodilla.",
    vote: "Äänestä: {{name}}",
    unvote: "Peru ääni: {{name}}",
    warning: {
      conflict: "Ristiriidassa: {{name}}",
      overlap: "Päällekkäinen: {{name}}",
      competing: "Kilpailee: {{name}}",
      needs: "Tarvitsee ensin: {{name}}",
      enables: "Mahdollistaa: {{name}}",
      reinforces: "Vahvistaa: {{name}}"
    },
    error: {
      CLOSED: "Äänestys on suljettu.",
      BUDGET: "Äänesi ovat loppu. Peru jokin ääni, jos haluat äänestää toista.",
      NO_SOLUTION: "Ratkaisua ei enää ole.",
      NO_VOTER: "Tätä laitetta ei tunnistettu äänestäjäksi.",
      generic: "Äänen tallennus epäonnistui: {{message}}"
    }
  },
  locked: {
    title: "Tulevaisuustestaukseen viedään",
    votes: "(ääniä: {{count}})",
    override: "Valinta poikkeaa äänestyksestä. Fasilitaattorin perustelu: {{reason}}",
    stale: "Näitä ratkaisuja on muokattu lukituksen jälkeen: {{names}}. Kuviteltu aikajana perustuu lukittuun versioon.",
    deleted: "(poistettu ratkaisu)"
  },
  admin: {
    title: "Tulevaisuustestaus: äänestys ja lukitus",
    loadError: "Tietojen lataus epäonnistui: {{message}}",
    interplayRead: "Ristivaikutukset on luettu.",
    interplayStale: "Ristivaikutukset on luettu, mutta ratkaisuja on muutettu sen jälkeen. Lue ne uudelleen ennen äänestystä toiminnolla Arvioi ristivaikutukset.",
    interplayMissing: "Ristivaikutuksia ei ole vielä luettu. Ne kannattaa lukea ennen äänestystä toiminnolla Arvioi ristivaikutukset.",
    votes: "Äänestys {{open}}, {{budget}} ääntä laitetta kohden. Avaa ja sulje äänestys yllä olevasta kytkimestä.",
    open: "auki",
    closed: "suljettu",
    tension: {
      overlap: "Päällekkäisyys valinnassa: {{a}} ja {{b}}",
      conflict: "Ristiriita valinnassa: {{a}} ja {{b}}. Lukitseminen on silti mahdollista; aikajana näyttää, mitä se maksaa."
    },
    overrideHint: "Valinta jättää pois ratkaisun, joka sai enemmän ääniä kuin jokin valituista. Kirjaa syy: huone näkee sen, ja se tallentuu raporttiin.",
    overridePlaceholder: "Miksi valinta poikkeaa äänestyksestä?",
    lock: "Lukitse {{count}} ratkaisua",
    relock: "Lukitse uudelleen ({{count}})",
    lockFailed: "Lukitus epäonnistui: {{message}}",
    openModule: "Avaa moduuli",
    currentLock: "Nykyinen lukitus ({{time}}): {{names}}"
  },
  howWeGotHere: "Miten tähän päädyttiin: ristivaikutukset",
  actor: {
    label: "Toimija",
    all: "Kaikki",
    hint: "Valitse organisaatiosi: sen askeleet korostuvat aikajanalla. Valinta muistetaan tällä laitteella.",
    count: "{{name}}: {{count}} askelta tässä kulussa",
    none: "{{name}} ei toimi tässä kulussa."
  },
  compare: {
    title: "Skenaariot rinnakkain",
    solution: "Ratkaisu",
    set: "Koko joukko",
    robustness: "Kestävyys",
    lines: "Aikajanat samalla vuosiakselilla",
    tooFew: "Vertailtavaa on, kun ainakin kaksi skenaariota on kuviteltu."
  },
  course: {
    causes: "Perustelut",
    title: "Kuviteltu kulku: mitä ratkaisuille voisi käydä",
    running: "Aikajanaa kuvitellaan…",
    failed: "Aikajanan kuvittelu epäonnistui: {{message}}",
    yearLikelihood: "{{year}} · {{likelihood}}",
    triggers: "Mistä se johtuu:",
    setAside: "Uhat, joiden ei arvioida toteutuvan:",
    threat: "{{what}} ({{when}}, {{likelihood}})",
    relation: "{{relation}}: {{a}} – {{b}}",
    wouldChange: "Mikä muuttaisi tämän: {{text}}",
    missing: "Näille ratkaisuille ei saatu perusteltua kohtaloa: {{names}}",
    until: "{{year}} asti",
    after: "vasta kun {{name}} on käynnissä"
  },
  effect: {
    title: "Vaikuttavuus: kuinka paljon ratkaisut ratkaisevat ongelman",
    intro: "Arvio tästä kulusta. Palvelin laskee, mihin vipupisteiden juurisyihin kukin ratkaisu yltää, ja laskee liian korkean arvion alemmas.",
    verdict: {
      marginal: "Ei juuri liikuta ongelmaa",
      eases: "Lievittää ongelmaa",
      fixes: "Korjaa ongelman",
      dissolves: "Poistaa ongelman lähtökohdan"
    },
    short: {
      marginal: "Ei juuri liikuta",
      eases: "Lievittää",
      fixes: "Korjaa",
      dissolves: "Poistaa lähtökohdan"
    },
    legend: {
      marginal: "ratkaisu yltää vain vähään tai ei mihinkään juurisyistä, tai se jää tässä kulussa liian vähäiseksi",
      eases: "ongelma pienenee tai lievenee, mutta suuri osa juurisyistä jää",
      fixes: "pääasialliset juurisyyt hoidetaan ja ongelma on pitkälti poissa, vaikka ympäröivä järjestelmä on ennallaan",
      dissolves: "paradigman muutos: juurisyyt poistuvat, ja ongelman lähtökohta on poissa"
    },
    set: "Koko ratkaisujoukko",
    perSolution: "Ratkaisut yksitellen",
    reached: "Yltää juurisyihin: {{names}}",
    reachedNone: "Ei yllä mihinkään vipupisteiden juurisyistä.",
    coverage: "{{reached}} / {{total}} juurisyystä",
    remaining: "Juurisyyt, joihin mikään toteutuva ratkaisu ei yllä: {{names}}",
    premiseGone: "Miksi ongelman lähtökohta poistuu: {{text}}",
    lowered: "Tekoäly arvioi: {{from}}. Kartan perusteella enintään: {{to}} ({{reason}}).",
    loweredReason: {
      reaches_none: "ratkaisu ei yllä yhteenkään juurisyyhyn",
      reaches_under_half: "se yltää alle puoleen juurisyistä",
      reaches_under_most: "se yltää alle neljään viidesosaan juurisyistä",
      premise_not_argued: "lähtökohdan poistumista ei perusteltu",
      no_root_causes: "vipupisteet eivät kanna juurisyitä, joihin sitä voisi verrata"
    },
    unjudged: "Tekoäly ei arvioinut tätä ratkaisua.",
    newIssues: "Uudet ongelmat, joita toteutus voisi synnyttää",
    newIssuesHint: "Päätelmiä, ei havaintoja: ne perustuvat ratkaisujen omiin vaikutuksiin, eikä niille ole lähdettä.",
    followsFrom: "Seuraa ratkaisuista: {{names}}",
    grounded: {
      adverse_move: "Perustuu siihen, että ratkaisu liikuttaa vipupistettä sen suuntaa vastaan",
      world_shift: "Perustuu kehitykseen, jota ratkaisu liikuttaa",
      reasoned: "Pelkkä päättely"
    },
    failed: "Vaikuttavuusarviota ei saatu: {{message}}",
    missing: "Vaikuttavuusarviota ei ole vielä tehty tälle kululle.",
    wall: "Vaikuttavuus: {{verdict}}"
  },
  fate: {
    realised: "Toteutuu",
    delayed: "Viivästyy",
    diminished: "Heikkenee",
    failed: "Kaatuu"
  },
  impact: {
    title: "Skenaario ja sen vaikutus",
    show: "Näytä skenaarion teksti",
    hide: "Piilota teksti"
  },
  likelihood: {
    low: "epätodennäköinen",
    medium: "mahdollinen",
    high: "todennäköinen"
  },
  line: {
    scrollHint: "Selaa sivusuunnassa →",
    step: "{{from}}–{{to}} · {{solution}}: {{step}}",
    stepActor: "Toimija: {{actor}}",
    stepPrecondition: "Edellytys: {{text}}",
    close: "Sulje"
  },
  narrativeKind: {
    milestone: "Virstanpylväs",
    side_effect: "Sivuvaikutus",
    setback: "Takaisku",
    turning_point: "Käännekohta",
    interaction: "Kohtaaminen"
  },
  panels: {
    stepCount: "{{count}} askelta",
    highlights: "Mitä kulun varrella huomataan",
    actions: "Toimenpiteet vuosittain",
    actionsFor: "Toimenpiteet vuosittain · {{name}} ensin",
    noActions: "Kulussa ei ole aikataulutettuja askeleita."
  },
  reading: {
    title: "Mitä skenaario tekee ratkaisujen uhille",
    pressure: {
      stronger: "vahvistaa",
      as_is: "ennallaan",
      weaker: "heikentää",
      removed: "poistaa"
    },
    timing: {
      earlier: "aiemmin",
      same: "",
      later: "myöhemmin"
    },
    kind: {
      trigger: "aiheutti kohtalon",
      setAside: "sivuutettu uhka"
    },
    behind: "Skenaariossa: {{text}}",
    none: "Skenaario ei muuta tämän kulun kohtaloiden uhkia.",
    differs: "Mikä skenaarioissa eroaa",
    differsIntro: "Uhat ja suhteet, joihin skenaariot vaikuttavat eri tavoin, ja skenaarion kohta, johon arvio perustuu. Kaikki skenaariot luettiin kerralla rinnakkain.",
    noDiffer: "Skenaariot eivät eroa lukittujen ratkaisujen uhkien osalta.",
    notRead: "Skenaarioita ei ole vielä luettu.",
    failed: "Skenaarioiden luenta epäonnistui: {{message}}"
  },
  robustness: {
    title: "Kestävyys: miten ratkaisut pärjäävät eri kuluissa",
    verdict: "Yhteenveto",
    holds: "Kestää kaikissa kuluissa",
    failsAll: "Kaatuu kaikissa kuluissa",
    fails: "Kaatuu jossain kulussa",
    diminishedAll: "Heikkenee kaikissa kuluissa",
    varies: "Vaihtelee kulun mukaan",
    unknown: "Ei tietoa"
  },
  scenario: {
    label: "Skenaario",
    sources: {
      expert: "Asiantuntijaskenaariot",
      workshop: "Työpajan skenaariot",
      own: "Omat skenaariot"
    },
    placeholder: "Paikkamerkki: asiantuntijoiden skenaariot korvaavat nämä tekstit.",
    stale: "Skenaario on muuttunut tämän kulun jälkeen: kulku pitää kuvitella uudelleen.",
    read: "Lue skenaario",
    close: "Sulje",
    level: "Optimismin taso {{level}}",
    judged: "Ratkaisut arvioidaan realistisesti tässä maailmassa: ei armollisesti eikä ankarasti."
  },
  timeline: {
    label: "Lukittujen ratkaisujen kuviteltu toteutus vuosittain",
    today: "Tänään",
    haze: "Ennusteen epävarmuus kasvaa pidemmälle tulevaisuuteen mentäessä",
    noNarrative: "Kertomusta ei saatu kirjoitettua; kulku ja kohtalot ovat silti alla. {{message}}"
  },
  worldAdmin: {
    title: "Skenaariot",
    source: "Lähde: {{source}}, {{count}} skenaariota. Lähteen voi vaihtaa Sisällöstä (Ennusteen skenaariot).",
    none: "Valitussa lähteessä on {{count}} skenaariota; tarvitaan vähintään {{min}}. Vaihda lähde tai lisää skenaariot Sisällössä.",
    simulate: "Kuvittele kaikki skenaariot",
    simulating: "Kuvitellaan…",
    rerun: "Kuvittele uudelleen",
    analyse: "Arvioi vaikuttavuus uudelleen",
    analysing: "Arvioidaan…",
    readingStatus: {
      running: "luetaan",
      done: "luettu",
      failed: "luenta epäonnistui"
    },
    status: {
      running: "kuvitellaan",
      done: "valmis",
      failed: "epäonnistui"
    }
  },
  lockedStrip: {
    label: "Lukittu",
    override: "Valinta poikkeaa äänestyksestä",
    stale: "muuttunut lukituksen jälkeen"
  },
  vipupisteet: {
    title: "Mitä vipupisteitä joukko liikuttaa, kun asiat menevät pieleen",
    hint: "Jokaisesta vipupisteestä, jota lukitut ratkaisut liikuttavat: mitkä ratkaisut liikuttavat sitä sen omaan suuntaan (↑) tai sitä vastaan (↓), ja mitä niille käy kussakin skenaariossa. Lukuja ei arvioida: vain se, toteutuuko liike.",
    type: { konsensus: "Yhteinen näkemys", kiistanalainen: "Kiistanalainen", villi_kortti: "Villi kortti", sokea_piste: "Sokea piste" },
    holds: "Liikkuu suuntaansa {{n}} / {{total}} skenaariossa",
    weakened: "heikentyneenä {{n}} skenaariossa",
    against: "suuntaansa vastaan {{n}} skenaariossa",
    solution: "Ratkaisu",
    noFate: "ei kohtaloa",
    none: "Lukitut ratkaisut eivät liikuta yhtään näytetyistä vipupisteistä.",
  },
  wall: { title: "Tulevaisuustestaus", intro: "Ratkaisut on arvioitu yksi kerrallaan vipupisteittäin. Tässä vaiheessa katsotaan, mitä ne tekevät toisilleen, valitaan pidettävät ja kuvitellaan, miten valittu joukko voisi toteutua. Kyse on kuvitelmasta, ei ennustuksesta: epävarmuudet sanotaan ääneen.", vision: "Kuvitelma, ei ennuste: jokainen hetki perustuu ratkaisujen omiin uhkiin ja niiden välisiin suhteisiin, ja sen epävarmuus on kerrottu." },
};
